import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import SubmissionDetails from '../../../SubmissionDetails';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import JournalViewer from '../../../DaEditorWrapper/Viewer/Journal';
import TextRenderer from '../../../TextRenderer';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import SubPaywall from '../../../DeviationViews/Full/_partials/SubPaywall';
import TextContent from '../../Details/_partials/TextContent';
import StatBlock from '../../Details/_partials/StatBlock';
import PremiumCover from '../_partials/PremiumCover';
import s from './Literature.scss';
var LiteratureContent = function (_a) {
    var textContent = _a.deviation.textContent, deviation = _a.deviation, _b = _a.withArtist, withArtist = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isPremiumLocked = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData).isPremiumLocked;
    var isMobile = useContext(MobileContext);
    var _c = useSubscriptionTier(deviation), isSubscribedButBlocked = _c.isSubscribedButBlocked, needsSubscription = _c.needsSubscription;
    var isBlocked = needsSubscription || isSubscribedButBlocked;
    // only show here in full screen, otherwise it's shown in DesktopLayout in the left column
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var shouldShowFullscreenSubPaywall = isBlocked && isFullscreen;
    return (React.createElement(React.Fragment, null,
        withArtist && (React.createElement("div", { className: s['author-block'] },
            React.createElement(SubmissionDetails, { deviation: deviation }),
            !isMobile && ' ')),
        React.createElement(StatBlock, { className: s['stats'], deviation: deviation }),
        React.createElement(Section, { className: classnames(s['wrapper'], isPremiumLocked && s['wrapper-with-paywall']) },
            React.createElement(VisuallyHidden, null,
                React.createElement(Heading, null, t('deviationview.literature.a11y.heading.content'))),
            !isBlocked &&
                isExtendedLoaded &&
                (isPremiumLocked ? (React.createElement(React.Fragment, null,
                    React.createElement(TextRenderer, { className: s['text-content-pf'], textContent: textContent, reactViewer: JournalViewer, viewerKey: deviation.deviationId, legacyTheme: "journal" }),
                    React.createElement(PremiumCover, { deviation: deviation }))) : (React.createElement(TextContent, { className: s['text-content'], textContent: textContent, deviationId: deviation.deviationId }))),
            shouldShowFullscreenSubPaywall && (React.createElement(SubPaywall, { className: s['paywall'], deviation: deviation, showImage: false })))));
};
LiteratureContent.displayName = 'LiteratureContent';
export default LiteratureContent;
//# sourceMappingURL=Literature.js.map